import {analyticsConstants} from '../../constants';
import {TelemetryGenericEnum} from '../../shared/enums';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';
import {GlobalAnalyticsVariablesInterface, TrackGuestPhotoEventPayloadInterface} from '../interfaces';

export const trackGuestPhotoEventCase = (
  payload: { interaction: string },
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackGuestPhotoEventPayloadInterface => {
  const data = retrieveTrackGuestPhotoEventPayload(payload);
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
}

const retrieveTrackGuestPhotoEventPayload = (
  payload: { interaction: string }
): TrackGuestPhotoEventPayloadInterface => ({
  eventType: TelemetryGenericEnum.INTERACTION_EVENT_TYPE,
  fluidVariable: analyticsConstants.GUEST_DETAILS.GUEST_PHOTO_FLUID_VARIABLE,
  interaction: payload.interaction,
  pageName: analyticsConstants.GUEST_DETAILS.PAGE_NAME,
})
